"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const building_blocks_ui_acko_analytics_1 = require("@acko-tech/building-blocks.ui.acko-analytics");
const car_details_widget_styles_1 = require("./car-details-widget.styles");
const r2d2_1 = require("./r2d2");
const chevronIcon_1 = __importDefault(require("./chevronIcon"));
function NewCarLink({ requestUrl, newCarRedirectionLink, okind, InsureSegmentTrackProps, }) {
    const handleBannerLink = (0, react_1.useCallback)(() => {
        Promise.allSettled([
            (0, building_blocks_ui_acko_analytics_1.trackEvent)('tap_btn_buying_new_car_click_here', Object.assign(Object.assign({}, InsureSegmentTrackProps), { widget_type: 'sticky widget' })),
            (0, r2d2_1.r2d2)({
                ekind: 'new_car_widget_clicked',
                okind: okind,
                oid: (0, r2d2_1.cookie)('trackerid'),
            }, requestUrl),
        ])
            .then(() => (window.location.href =
            newCarRedirectionLink || '/lp/new-comprehensive/new-car/details'))
            .catch((error) => {
            console.log(error);
        });
    }, []);
    return (react_1.default.createElement(car_details_widget_styles_1.RootContainer, { mt: "28px" },
        react_1.default.createElement(car_details_widget_styles_1.BannerContainer, { onClick: handleBannerLink },
            react_1.default.createElement(car_details_widget_styles_1.BannerText, { size: "xxs" }, "Buying a new car?"),
            react_1.default.createElement(car_details_widget_styles_1.BannerLink, { size: "xxs" },
                "Click here! ",
                react_1.default.createElement(chevronIcon_1.default, { alt: "click arrow" })))));
}
exports.default = NewCarLink;
//# sourceMappingURL=NewCarLink.js.map